import styles from "../styles/Users.module.css";
import axios from "axios";
import { User } from "../models/user";
import * as UserApi from "../network/user_api";
import { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import UserIcon from "../assets/usericon.png";
import { BsTrash3 } from "react-icons/bs";
import { BiSolidUserPlus } from "react-icons/bi";
import TextInputField from "../components/form/TextInputField";
import { ConflictError } from "../errors/http_errors";
import { useForm } from "react-hook-form";
import { UserProps } from "../network/user_api";

interface AdminPageProps {
    loggedInUser: User | null;
}

const AdminPage = ({ loggedInUser }: AdminPageProps) => {

    const [userList, setUserList] = useState<UserProps[]>([]);
    const [errorText, setErrorText] = useState<string | null>(null);
    const userColors = ['20B2AA', '87CEFA', '7B68EE', 'FFA07A', 'BA55D3', 'FF4500', '191970', 'DDA0DD', 'DB7093', '663399', 'FFB6C1', 'FF8C00'];
    const [isUserRemoved, setIsUserRemoved] = useState<boolean>(false);
    
    const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm<UserProps>();

    async function onRegister(newUser: UserProps) {
        try {
            const user = await UserApi.register(newUser);
            setUserList(prevUsers => [...prevUsers, user]);
            setErrorText('');
            reset();    //Reset the form fields
        } catch (error) {
            if (error instanceof ConflictError ) {
                setErrorText(error.message);
            } else {
                alert(error);
            }
            console.error(error);
        }
    }
    
    async function onRemove(user: UserProps) {
        try {
            await UserApi.remove(user);
            setIsUserRemoved(true);
        } catch (error) {
            alert(error);
            console.error(error);
        }
    };

    useEffect(() => {
        const getUserList = async () => {
            try {
                const response = await axios.get<UserProps[]>("/api/users/userlist", {});
                setUserList((response.data));
                setIsUserRemoved(false);
            } catch (error) {
                console.error(error);
            }
        };
        getUserList();
    }, [isUserRemoved]);

    return (
        (loggedInUser && (loggedInUser.username === "dp@locs.gr" || loggedInUser.username === "kl@locs.gr"))
        ?
            <div>
            <Row className="justify-content-center mx-1 mt-3 row-cols-xs-1 row-cols-md-2 row-cols-xl-3">
                <Col>
                    <h5 className="bg-success text-light p-2 mb-0">Εγγραφή νέου χρήστη</h5>
                    <Form className="w-100 bg-light pt-2 pb-1 pt-0 px-3 mb-4" onSubmit={handleSubmit(onRegister)}>
                        
                        {errorText &&
                        <Alert variant="danger">
                            {errorText}
                        </Alert>
                        }
                        {errors.username && <Alert variant="danger">Πρόβλημα με τη μορφή του email</Alert>}
                            <TextInputField
                            name="username"
                            autoComplete="off"
                            label="e-mail"
                            type="text"
                            placeholder=""
                            register={register}
                            registerOptions={{ required: "Απαιτείται το email του χρήστη", pattern:/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i }}
                            error={errors.username}
                        />
                        <TextInputField
                            name="password"
                            label="Password"
                            type="password"
                            placeholder=""
                            autoComplete="off"
                            register={register}
                            registerOptions={{ required: "Απαιτείται κωδικός για τον χρήστη" }}
                            error={errors.password}
                        />
                        <TextInputField
                            name="firstname"
                            label="Όνομα"
                            type="text"
                            placeholder=""
                            register={register}
                            registerOptions={{ required: "Απαιτείται το όνομα του χρήστη" }}
                            error={errors.firstname}
                        />
                        <TextInputField
                            name="lastname"
                            label="Επίθετο"
                            type="text"
                            placeholder=""
                            register={register}
                            registerOptions={{ required: "Απαιτείται το επίθετο του χρήστη" }}
                            error={errors.lastname}
                        />
                        <Button className="has-icon btn-block px-2 mb-3 mx-auto d-flex" variant="primary" type="submit" disabled={isSubmitting}><BiSolidUserPlus className={`${styles.BiSolidUserPlus} mx-1`} />Εγγραφή</Button>
                    </Form>
                </Col>
            </Row>
            <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 gutters-sm m-2">
                {userList.map((user, index) => (
                    <Col className="mb-3" key={user.userId}>
                        <Card className={`${styles.userCard} h-100`}>
                            <div className={`${styles.CardColorBox} `} style={{backgroundColor: `#${userColors[index%userColors.length]}`}}></div>
                            <Card.Body className="text-center">
                                <img src={UserIcon} alt="User" className={`${styles.AvatarImg} img-fluid img-thumbnail rounded-circle border-0 mb-3`} />
                                <Card.Title>{user.lastname} {user.firstname}</Card.Title>
                                <p className="text-secondary mb-1">{user.username}</p>
                            </Card.Body>
                            <Card.Footer>
                                <Button className="btn-sm bg-primary has-icon bnt-block px-2 d-flex" type="button" onClick={()=>onRemove(user)}><BsTrash3 className={`${styles.BsTrash3} mx-1`} />Διαγραφή</Button>
                            </Card.Footer>
                        </Card>
                    </Col>
                ))
                }
            </Row>
        </div>
        : <></>
    );
};

export default AdminPage;